import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    serviceList: () => {
        return HTTP.get('/service_current/1', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    editService: (data) => {
        return HTTP.post('/service_updtae/1',data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}